/**
 * © 2024 Tandem Diabetes Care, Inc. All rights reserved.
 * Confidential Information of Tandem Diabetes Care, Inc.
 * Internal Use Only
 */

import type { FC, PropsWithChildren } from 'react';
import PreloadAnalytics from '../components/PreloadAnalytics';

const PreloadAnalyticsExport: FC<PropsWithChildren> = ({ children }) => (
  <PreloadAnalytics>{children}</PreloadAnalytics>
);

export default PreloadAnalyticsExport;
